export const getCareerAptitudeQuestionsAPI = "/career-aptitude-test-questions";
export const createCareerAptitudeQuestionAPI =
  "/career-aptitude-test-questions";
export function deleteCareerAptitudeQuestionAPI(id) {
  return "/career-aptitude-test-questions/" + id;
}
export function editCareerAptitudeQuestionAPI(id) {
  return "/career-aptitude-test-questions/" + id;
}
